<template>
  <v-dialog persistent v-model="show" max-width="800px">
    <v-card flat class="pl-10 pr-10">
      <v-card-title class="justify-center">
        <v-icon large left color="orange"> mdi-ab-testing </v-icon>
        <span class="text-h6">New Network (vs Baseline) Scan</span>
      </v-card-title>
      
      <v-divider></v-divider>
      <v-form class="pt-10 pb-10">
        <v-row>
          <v-col cols="12" sm="9">
            <v-select
              v-model="select"
              :items="systems"
              return-object
              item-text="name"
              label="System"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3" class="d-flex justify-center align-center">
            <div>
              <a class="text-decoration-none" @click="snackbar_visible = true"
                >Add New System ...</a
              >
            </div>
          </v-col>
        </v-row>
        <v-file-input label="Upload PCAP File"></v-file-input>
        <v-file-input label="Upload Basline PCAP File"></v-file-input>
        <v-text-field single-line label="Endpoint IP Addresses"></v-text-field>

        <v-divider></v-divider>

        <v-card-actions class="pt-5">
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" @click="snackbar_visible = true"
            >Start</v-btn
          >
          <!-- <v-btn @click="$router.push({name: 'new'})">Cancel</v-btn> -->
          <v-btn depressed @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <v-snackbar color="error" v-model="snackbar_visible" :timeout="snackbar_timeout">
      {{ snackbar_text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          plain
          snackbar_text
          v-bind="attrs"
          @click="snackbar_visible = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    show: true,
    snackbar_visible: false,
    snackbar_text: "Demo instance - functionality disabled",
    snackbar_timeout: 2000,
    select: {
      name: "",
      pstrings: "",
      estrings: "",
    },
    systems: [
      {
        name: "SecureDrop",
        pstrings: "AProjectString",
        estrings: "XYZNews, AnExplicitString",
      },
      {
        name: "NotSoSecureDrop",
        pstrings: "AProjectString",
        estrings: "XYZNews, AnExplicitString",
      },
    ],
  }),
  watch: {
    select: function (val) {
      console.log(val);
    },
  },
  methods: {
    close () {
      this.$emit('update', null)
    }
  }
};
</script>
